import { createRootRoute } from '@tanstack/react-router'
import { RootLayout } from './RootLayout'
import { RootRouteErrorComponent } from './RootRouteErrorComponent'

export const rootRoute = createRootRoute({
  component: RootLayout,
  errorComponent: RootRouteErrorComponent,
})
